import { esBodasPalettes } from "../../../../Posts/05-tematicas/07-bodas/bodasPalettes.js";
import * as React from 'react';
export default {
  esBodasPalettes,
  React
};